/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";

import { FiChevronsDown } from "components/atoms/Icon/fi/FiChevronsDown";

import RelatedPosts from "../RelatedPosts";
import TableOfContents from "../TableOfContents";

import styles from "./Index.module.scss";

const RenderTocOrRelated = ({ children, post, relatedPosts }) => {
  const tocRef = useRef();
  const [visited, setVisited] = useState();
  const [contentLongerThanScreen, setContentLongerThanScreen] = useState(false);
  const toc = JSON.parse(post.tableOfContents);
  const [y, setY] = useState(0);

  function isScrolledIntoViewTop(el) {
    if (el) {
      const { top, bottom } = el?.getBoundingClientRect() || 0;

      return (
        top > 80 &&
        top <= window.innerHeight / 2 &&
        bottom <= window.innerHeight
      );
    }
  }
  function isScrolledIntoViewBottom(el) {
    if (el) {
      const { bottom } = el?.getBoundingClientRect() || 0;
      const space = window.innerHeight - bottom;

      return space > 0 && space < window.innerHeight / 8;
    }
  }

  const checkTocLength = () => {
    if (toc.length > 0) {
      if (toc.length > 2) return true;

      let lengthOfChildren = 0;

      for (let index = 0; index < toc.length; index++) {
        const element = toc[index];

        if (element.children && element.children.length > 0) {
          lengthOfChildren += element.children.length;
        }
      }

      return lengthOfChildren >= 3;
    }

    return false;
  };

  useEffect(() => {
    function getParentNode(element) {
      return element?.parentNode.parentNode?.parentElement;
    }
    function highlightElement(element) {
      element.classList.add("text-bbc-brand-500");
      if (element.parentNode.parentNode?.parentElement) {
        setVisited(getParentNode(element).childNodes[0].hash);
      }
    }

    if (checkTocLength()) {
      window.onscroll = () => {
        // Highlight visited Big Title

        const getTitleList = document.querySelectorAll("#post-content h2");

        for (let index = 0; index < getTitleList.length; index++) {
          const element = getTitleList[index];

          if (isScrolledIntoViewTop(document.getElementById(element.id))) {
            setVisited(`#${element.id}`);
            break;
          } else if (
            isScrolledIntoViewBottom(document.getElementById(element.id))
          ) {
            // Highlight before subtitle on menu on scroll up from big title

            if (index > 0) {
              setVisited(`#${getTitleList[index - 1]?.id}`);
              const getTitleListId = document.querySelectorAll(
                "#post-content h2,h3"
              );
              const indexOfVisited = Array.from(getTitleListId).findIndex(
                (item) => item.id === getTitleList[index].id
              );

              if (indexOfVisited) {
                const elementChild = getTitleListId[indexOfVisited - 1];

                if (
                  elementChild.tagName === "H3" &&
                  document.querySelector(
                    `#toc-desktop a[href='#${elementChild.id}']`
                  )
                ) {
                  document
                    .querySelector(`#toc-desktop a[href='#${elementChild.id}']`)
                    .classList.add("text-bbc-brand-500");
                }
              }
            }
          }
        }
        // Highlight subtitle on menu on scroll
        const getTitleList2 = document.querySelectorAll("#post-content h3");

        getTitleList2.forEach((item) => {
          if (isScrolledIntoViewTop(document.getElementById(item.id))) {
            const listItemMenu = document.querySelectorAll(
              "#toc-desktop li ul a"
            );

            for (let i = 0; i < listItemMenu.length; i++) {
              const element = listItemMenu[i];

              element.classList.remove("text-bbc-brand-500");
              if (element.hash === `#${item.id}`) {
                highlightElement(element);
              }
            }
          } else if (
            isScrolledIntoViewBottom(document.getElementById(item.id))
          ) {
            // Highlight before subtitle on menu on scroll up
            const listItemMenu = document.querySelectorAll(
              "#toc-desktop li ul a"
            );

            for (let i = 0; i < listItemMenu.length; i++) {
              const element = listItemMenu[i];

              if (element.hash === `#${item.id}`) {
                element.classList.remove("text-bbc-brand-500");
                if (
                  getParentNode(
                    listItemMenu[i - 1]
                  )?.childNodes[0].classList.contains("text-bbc-brand-500")
                ) {
                  listItemMenu[i - 1].classList.add("text-bbc-brand-500");
                }
              }
            }
          }
        });
        // Collapse TOC if User Scroll on Blog's Content. Expand if user on the top of blog's content
        if (
          tocRef.current.getBoundingClientRect().top === 178 &&
          tocRef.current.getBoundingClientRect().top > 0
        ) {
          tocRef.current.classList.add(styles.collapse);
        } else {
          tocRef.current.classList.remove(styles.collapse);
        }
        setY(window.scrollY);
      };
    }
  }, [y, toc]);

  function scrollTo(element, to, duration) {
    const start = element.scrollTop;
    const change = to - start;
    let currentTime = 0;
    const increment = 20;

    const animateScroll = () => {
      currentTime += increment;
      const val = Math.easeInOutQuad(currentTime, start, change, duration);

      // eslint-disable-next-line no-param-reassign
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };

    animateScroll();
  }
  useEffect(() => {
    // Highlight visited Big Title
    if (visited) {
      document
        .querySelectorAll("#toc-desktop a")
        ?.forEach((item) => item.classList?.remove("text-bbc-brand-500"));
      document
        .querySelector(`#toc-desktop a[href='${visited}']`)
        ?.classList?.add("text-bbc-brand-500");

      Math.easeInOutQuad = (t, b, c, d) => {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t -= 1;

        return (-c / 2) * (t * (t - 2) - 1) + b;
      };

      const el = document.getElementById("toc-desktop");
      const targetElm = document?.querySelector(
        `#toc-desktop a[href='${visited}']`
      );
      const topPos = targetElm?.offsetTop;

      scrollTo(el, topPos - 90, 300);
    }
  }, [visited]);

  useEffect(() => {
    function renderTocOnResizeScreen() {
      if (
        document.getElementById("toc-list-table").offsetHeight >
        window.innerHeight * 0.8
      ) {
        setContentLongerThanScreen(true);
      } else {
        setContentLongerThanScreen(false);
      }
    }
    if (checkTocLength()) {
      renderTocOnResizeScreen();
    }
    window.addEventListener("resize", renderTocOnResizeScreen);

    return window.removeEventListener("resize", renderTocOnResizeScreen);
  }, [toc]);

  if (checkTocLength()) {
    return (
      <div className="sticky top-32 mb-10 text-bbc-brand-800 lg:mb-0 ">
        <div
          className={`${styles.toc} group rounded-xl  px-4 hover:cursor-pointer lg:bg-white lg:py-2`}
        >
          <span className="flex items-center justify-between py-2 font-medium group-hover:text-bbc-brand-500">
            Table of Contents{" "}
            <FiChevronsDown className="float-right hidden align-middle lg:inline-block " />
          </span>

          <div
            ref={tocRef}
            id="toc-desktop"
            className={`${styles.tocDesk} hidden ${
              contentLongerThanScreen ? "overflow-y-auto" : "overflow-hidden"
            } scroll-smooth pr-8 transition-all duration-300 lg:block`}
          >
            <TableOfContents data={toc} />
          </div>

          <div className="block lg:hidden">
            <TableOfContents data={toc} />
          </div>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8 text-bbc-brand-800 lg:mb-0 ">
        <RelatedPosts data={relatedPosts} />
      </div>
      {children}
    </div>
  );
};

export default RenderTocOrRelated;
